import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useTranslations } from "@/hooks/useTranslations";
import { useNotify } from "@/hooks/useNotify";
import IngredientCostRepository from "@/utils/API/IngredientCostRepository";
import { getErrorMessage } from "@/utils/Helpers";
import VModal from "@/components/vModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vAddVendorModal',
  props: {
  show: { type: Boolean, required: true }
},
  emits: ['close', 'vendorAdded'],
  setup(__props, { emit }) {

const props = __props;





const translations = useTranslations();
const notify = useNotify();

const vendorName = ref("");

async function saveVendor() {
  if (!vendorName.value.trim()) {
    notify.error("The vendor name cannot be empty.");
    return;
  }

  try {
    const response = await IngredientCostRepository.createIngredientCostVendor(vendorName.value);
    const vendorList = response.data.result;
    notify.success("The vendor has been added successfully.");
    emit("vendorAdded", vendorList);
    emit("close");
    vendorName.value = "";
  }
  catch (err) {
    notify.error(getErrorMessage(err, translations));
  }
}

return { __sfc: true,props, emit, translations, notify, vendorName, saveVendor, VModal }
}

})